import { useTranslation } from "react-i18next";
import React, { ReactNode, useState } from "react";
import { Modal } from "antd";
import {
  GroupsExam,
  QuestionBeProps,
  QuizProps,
} from "../../../../../../types/course";
import EmptyComponent from "../../../../../../components/empty";

interface ScoreDetailModalProps {
  children?: ReactNode;
  data: GroupsExam[];
}

function ScoreDetailModal({ children, data }: ScoreDetailModalProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const displayScore = (quizzes: QuizProps[]) => {
    if (!quizzes?.length) return `0/0`;

    let scores = 0;
    let maxScores = 0;
    quizzes.forEach((quiz: QuizProps) => {
      if (quiz?.result) {
        scores += quiz?.result?.points;
        maxScores += quiz?.result?.totalPoints;
      }
    });
    return `${scores}/${maxScores}`;
  };

  const renderContent = () => {
    if (!data?.length)
      return (
        <div className="row center">
          <EmptyComponent description={t("Chưa có nhận xét", "Chưa có nhận xét")} />
        </div>
      );

    return data?.map((group: GroupsExam, index: number) => (
      <div className="row" key={group?.id}>
        <div className="cell">
          {t("Phần", "Phần")} {index + 1 || t("Không có tên", "Không có tên")} <p>({group?.quiz?.length} {t("câu)", "câu)")}</p>
        </div>
        <div className="cell font-weight-6">{group?.title}</div>
        <div className="cell">{displayScore(group?.quiz)}</div>
      </div>
    ));
  };

  return (
    <div>
      <div onClick={showModal}>{children}</div>
      <Modal
        title={
          <span className="font-size-24 line-height-32 font-weight-6">
            {t("Bảng điểm chi tiết", "Bảng điểm chi tiết")}
          </span>
        }
        width={708}
        open={open}
        maskClosable={false}
        centered
        className="score-detail-modal"
        onCancel={hideModal}
      >
        <div className="score-detail-table">
          <div className="row score-table-header">
            <div className="cell">{t("Phần bài", "Phần bài")}</div>
            <div className="cell">{t("Tên phần", "Tên phần")}</div>
            <div className="cell">{t("Điểm số", "Điểm số")}</div>
          </div>
          {renderContent()}
        </div>
      </Modal>
    </div>
  );
}

export default ScoreDetailModal;
